export const logConstants = {
    CONTENT_ACTIVITY_LIST_SUCCESS: "CONTENT_ACTIVITY_LIST_SUCCESS",
    CONTENT_ACTIVITY_LIST_FAILURE: "CONTENT_ACTIVITY_LIST_FAILURE",
    CONTENT_ACTIVITY_LIST_REQUEST: "CONTENT_ACTIVITY_LIST_REQUEST"
};
